import { useEffect } from 'react';
import axios from 'axios';
import { RequirePadAgreementRequest, RequirePadAgreementResponse } from 'vopay';
import vopayApi from '../../services/api.config';

const hook = vopayApi.withApiHook(({ api }) => {
  return function useValidate() {
    const source = axios.CancelToken.source();

    const requirePadAgreement = async (
      requestParams: RequirePadAgreementRequest,
      bearer: string,
    ): Promise<RequirePadAgreementResponse> => {
      try {
        const res = await api.postRequirePadAgreement(requestParams, source, bearer);

        if (res.Success) {
          return {
            Success: res.Success,
            ErrorMessage: '',
            RequiresPADAgreement: res.RequiresPADAgreement,
          };
        }
      } catch (error) {
        console.error(error);
      }

      return {
        Success: false,
        ErrorMessage: 'Failed',
        RequiresPADAgreement: false,
      };
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      requirePadAgreement,
    };
  };
});

export default hook({});
